require('../../brokerPensionPlanContribution.scss');

const PropTypes = require('prop-types');

// @vendor
const React = require('react');
const { formatText, FormattedText } = require('core/i18n').i18n;
const { withRouter } = require('react-router-dom');

// @commons
const WizardSuccess = require('components/commons/wizardSuccess/wizardSuccess');
const PensionPlanContributionSummary = require('components/broker/commons/pensionPlanContributionSummary/pensionPlanContributionSummary');
// @helpers
const {
    FIRST_STEP,
    BROKER_STOCKS_BUY_SELL_SUMMARY_BUY_MODIFIER,
    CHARGE_ACCOUNT_PREFIX
} = require('constants/index');

class pensionPlanExtraordinarySuccess extends React.Component {

    constructor(props) {
        super(props);
        this.handleSecondaryClick = this.handleSecondaryClick.bind(this);
    }

    handleSecondaryClick() {
        const { history, immPensionPlanContribution } = this.props;
        const contractNumber = immPensionPlanContribution.get('contractNumber');
        history.replace('/myprofile/broker/ordersAndMovements/' + contractNumber);
    }

    render() {
        const { immPensionPlanContribution } = this.props;
        const successMessage = formatText('pensionPlanContribution-extraordinarySuccessMessage');
        const mainButtonLabel = formatText('pensionPlanContribution-successMainButton');
        const secondaryButtonLabel = formatText('pensionPlanContribution-successSecondaryButton');
        const step1 = immPensionPlanContribution.get('steps').get(FIRST_STEP);
        const plan = immPensionPlanContribution.get('pensionPlan');
        const walletPlan = immPensionPlanContribution.get('pensionPlanFromWallet');
        const contractNumber = walletPlan.getIn(['contrato', 'numerodecontrato']);
        const productNumber = walletPlan.getIn(['contrato', 'producto']);
        const chargeAccount = `${CHARGE_ACCOUNT_PREFIX}${productNumber}${contractNumber}`;
        const planData = immPensionPlanContribution.get('extraordinaryData');
        const validationData = immPensionPlanContribution.get('validationData');

        return (

            <WizardSuccess
                successMessage={successMessage}
                customClassName="etfs-buy-success"
                mainButton={{ label: mainButtonLabel, url: '/myprofile/broker' }}
                secondaryButton={{ label: secondaryButtonLabel }}
                onSecondaryButtonClick={this.handleSecondaryClick}
            >
                <h2 className="broker-pension-plan-contribution__title">
                    <FormattedText value="pensionPlanContribution-step1Title" />
                </h2>
                <PensionPlanContributionSummary
                    productName={formatText('broker-etfProductName')}
                    plan={plan}
                    walletPlan={walletPlan}
                    planData={planData}
                    validationData={validationData}
                    planContractNumber={chargeAccount}
                    step1={step1}
                    modifier={BROKER_STOCKS_BUY_SELL_SUMMARY_BUY_MODIFIER}
                    columns={4}
                />
            </WizardSuccess>
        );
    }
}

pensionPlanExtraordinarySuccess.propTypes = {
    history: PropTypes.object.isRequired,
    immPensionPlanContribution: PropTypes.object.isRequired,
    immStocksContracts: PropTypes.object.isRequired
};

module.exports = withRouter(pensionPlanExtraordinarySuccess);
